import React from 'react';
import emptyImg from '@/assets/image/empty-img.png';

import cx from './index.module.scss';

interface Props {
  className?: string;
}

const EmptyBox: React.FC<Props> = props => {
  const { className } = props;

  return (
    <div className={cx('empty-wrapper', className)}>
      <img src={emptyImg} />
      <div>当前无图片</div>
    </div>
  );
};

export default EmptyBox;
